import { BadgeDomain } from "./BadgeDomain";

export function YesNoBadge({ value, size }) {
  const text = value ? "Tak" : "Nie";
  const bg = value ? "success" : "secondary";

  return <BadgeDomain bg={bg} size={size}>{text}</BadgeDomain>;
}